import env from "@/env";
import { getToken } from "@/utils/api";
import {
  CreateSshKeyInput,
  SavedSshKey,
  SavedSshKeyCreateResponse,
  SavedSshKeyListResponse
} from "@/types/savedSshKey";

const getBaseUrl = () => env.SSH_KEYS_API_URL || "/api/ssh-keys";

const request = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const token = getToken();
  if (!token) {
    throw new Error("You must be signed in to manage SSH keys");
  }

  const response = await fetch(`${getBaseUrl()}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...(init?.headers ?? {})
    }
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(
      typeof data.error === "string" ? data.error : "Failed to manage SSH keys"
    );
  }
  return data as T;
};

export const listSshKeys = async (): Promise<SavedSshKey[]> => {
  const data = await request<SavedSshKeyListResponse>("");
  return data.keys ?? [];
};

export const createSshKey = async (input: CreateSshKeyInput): Promise<SavedSshKey> => {
  const data = await request<SavedSshKeyCreateResponse>("", {
    method: "POST",
    body: JSON.stringify(input)
  });
  return data.key;
};

export const deleteSshKey = async (id: string): Promise<void> => {
  await request<{ success: boolean }>(`?id=${encodeURIComponent(id)}`, {
    method: "DELETE"
  });
};
